import React from 'react';
import styles from '../../css/Footer.module.css';
import { FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
	return (
		<div className={styles.copyrgt}>
			<p style={{ color: 'white' }}>
				© 2023 KANASU EDUCATIONAL AND CHARITABLE TRUST ALL RIGHTS RESERVED.
			</p>
			<p className={styles.dev}>DESIGNED AND DEVELOPED BY TEJAS</p>
			<div className={styles.row}>
				<a href="tel:+91 8884264377" className={styles.number}>
					8884264377
				</a>
				<a href="https://wa.me/+918884264377" target="_blank" rel="noreferrer">
					<FaWhatsapp className={styles.icon} />
				</a>
			</div>
		</div>
	);
};

export default Footer;
